import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { RepeatType } from '../shipment-edit-dialog.component';

/** 配送設定のオプションフォームグループ */
export type ShipmentOptionFormGroup = FormGroup<{
  /** 配送設定名 */
  shipmentName: FormControl<string>;

  /** 繰り返し作成 */
  repeatType: FormControl<RepeatType>;
}>;

@Component({
  selector: 'app-shipment-option-edit',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
  ],
  templateUrl: './shipment-option-edit.component.html',
  styleUrl: './shipment-option-edit.component.scss',
})
export class ShipmentOptionEditComponent {
  /** 配送設定のオプションフォームグループ */
  @Input({ required: true }) formGroup!: ShipmentOptionFormGroup;

  /** 既存互換のため残置（親からのイベント契約維持用） */
  @Output() deviceSearched = new EventEmitter<void>();
}
